// Personalize your Substack URL before publishing.
const siteSettings = {
  substackUrl: "https://celinaryan.substack.com/",
  linkedInUrl: "https://www.linkedin.com/in/celina-ryan-nd-va/"
};

export const hasConfiguredSubstack = !siteSettings.substackUrl.includes("your-publication");

export default siteSettings;
